import * as microsoftTeams from "@microsoft/teams-js";
import { getAdminCenterDialogUrl } from "./AdminCenterDialogRelay";
/**
 * Opens an Admin Center page: in a Teams dialog, through this app's relay page so that Admin Center
 * gets the user's SSO token (see getAdminCenterDialogUrl); in a browser window on Map and mobile.
 */
export const IframeManager = (iframeConfig, isOnMobile, appInsightInstance, from, adminCenterUrl, redirectUrlForMapOrMobile, dataFunction) => {
    // appInsightInstance is {} until App Insights is set up: calling trackEvent on it would throw before the dialog opens.
    if (iframeConfig.trackingIds.open !== null)
        appInsightInstance?.trackEvent?.({ name: iframeConfig.trackingIds.open });
    if (from == "Map" || isOnMobile) {
        window.open(redirectUrlForMapOrMobile);
    }
    else {
        microsoftTeams.dialog.url.open({
            url: getAdminCenterDialogUrl(adminCenterUrl),
            size: {
                width: iframeConfig.width,
                height: iframeConfig.height,
            },
        }, (data) => {
            dataFunction(data);
        });
    }
};
